import Vue from 'vue';
import App from './App.vue';

import store from './store';
import router from './router';

import 'bootstrap-vue/dist/bootstrap-vue.css';

import { registerAnalytics } from './Scripts/Config/Analytics';
import { registerIcons } from './Scripts/Config/Icons';
import { registerFilters } from './Scripts/Config/Filters';
import { registerBootstrapVue } from './Scripts/Config/BootstrapVue';
import { registerScrollTo } from './Scripts/Config/ScrollTo';

registerAnalytics(router);
registerIcons();
registerFilters();
registerBootstrapVue();
registerScrollTo();

Vue.config.productionTip = false;

new Vue({
	store,
	router,
	render: (h) => h(App)
}).$mount('#app');
